import React from 'react'
import { observer } from 'mobx-react'
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
} from 'components/Table/ClickableTable'
import ScopeChangeRequestsViewModel from 'admin/scope-change-requests/ScopeChangeRequestsViewModel'
import ScopeChangeRequestRow from '../ScopeChangeRequestRow'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'

interface ScopeChangeRequestTableProps {
  vm: ScopeChangeRequestsViewModel
}

export default observer(function ScopeChangeRequestTable({
  vm,
}: ScopeChangeRequestTableProps) {
  const columns = vm.columns

  return (
    <>
      <Table striped>
        <TableHead>
          {columns.map((col) => (
            <TableHeader
              key={col.id}
              canSort={col.sortable}
              sortOrder={vm.getSortOrder(col)}
              onSort={(newSort) => {
                vm.setSortOrder(col, newSort)
              }}
            >
              {col.header}
            </TableHeader>
          ))}
        </TableHead>
        <TableBody>
          {vm.filteredItems.map((item) => (
            <ScopeChangeRequestRow
              vm={vm}
              scopeChangeRequest={item}
              key={item.id}
            />
          ))}
        </TableBody>
      </Table>
      <InfiniteScrollLoader scrollProvider={vm.searcher.scroller} />
    </>
  )
})
